import { Evidence } from "@p0security/shared/types/evidence";
import { Flex, Typography } from "@p0security/ui";
import React, { type ReactNode } from "react";

import { renderPreApproval } from "../requestRenderUtils";

export const UserCell: React.FC<{
  icon: ReactNode;
  username: ReactNode;
  subtitle?: ReactNode;
  preApproval?: readonly [Evidence["source"], string] | "unknown";
}> = ({ icon, username, subtitle, preApproval }) => {
  return (
    <Flex align="center" gap={8}>
      {icon}
      <Flex vertical className="min-w-0">
        <Typography.Text ellipsis={{ tooltip: true }}>
          {username}
        </Typography.Text>
        {subtitle}
        {preApproval && (
          <Typography.Text className="sub-text" type="secondary">
            {renderPreApproval(preApproval, true)}
          </Typography.Text>
        )}
      </Flex>
    </Flex>
  );
};
